import { LogEvents, logger } from 'lib/common/components/LoggerController';

import { TConfig } from 'lib/common/types/Config';
import toast from 'lib/common/utils/toast';

export default async function handleConnectSignOut({ config }: { config: TConfig }) {
  try {
    await Promise.all(
      [config.CONNECT_HOST, config.ACGR?.secondaryCCPUrl]
        .filter((url) => !!url)
        .map((url) =>
          fetch(`${url}/connect/logout`, {
            credentials: 'include',
            mode: 'no-cors',
          })
        )
    );
  } catch (error) {
    toast('error', "Oops, sign out didn't work as expected. Please try again or reload the page.");
    logger.error(LogEvents.AUTH.SIGN_OUT.COMPLETED.FAIL, { error });
    return;
  }

  // @ts-ignore https://github.com/amazon-connect/amazon-connect-streams/issues/907#issuecomment-2372655570
  connect.core.getUpstream().sendUpstream(connect.EventType.TERMINATE);

  connect.core.terminate();
}
